module.exports = '1.3.0';



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/version.js
// module id = 122
// module chunks = 1